import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSignOut } from 'src/api/provider';
import { ROOT_DOMAIN } from 'src/constants/environment';
import { validateRedirectUrl } from 'src/lib/utils/url';

export const SignOut = () => {
    const signOut = useSignOut();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const nextPath = params.get('next');
        let redirectTo = '/login';

        if (nextPath && ROOT_DOMAIN) {
            if (validateRedirectUrl(nextPath, ROOT_DOMAIN)) {
                redirectTo = `/login?next=${encodeURIComponent(nextPath)}`;
            }
        }
        signOut(redirectTo);
    }, [signOut, location.search]);

    return null;
};
